import {DetailTable} from '../../../mapping-classes/detail-table';

export class Idealprofilecards implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(idealProfileCards: any) {
    if (!idealProfileCards || idealProfileCards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = idealProfileCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(idealProfileCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'iban',
      'consentTime',
      'revokeConsentTime',
      'consentText',
    ];
  }

  setRowData(idealProfileCards) {
    idealProfileCards.forEach((idealProfileCard) => {
      if (this.restrictedData) {
        idealProfileCard.compensationLimit = this.shieldedText;
        idealProfileCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(idealProfileCard);
    });
  }
}
